import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-gtag';
import { EuiSpacer, EuiButton } from '@elastic/eui';
import YoutubeCards from 'components/Indoor_Cameras/IN-6012_HD/Usermanual/YoutubeVideoCard';
import NavButtons from 'components/Indoor_Cameras/IN-6012_HD/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  OutboundLink,
  EuiSpacer,
  EuiButton,
  YoutubeCards,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};